// Production-mode build (service worker / push notifications enabled)
// but pointing at the local backend instead of the live production API.
// Build with: ng build --configuration local-prod

export const environment = {
  production: true,
  host: typeof window === 'undefined'
    ? 'http://127.0.0.1:3000'
    : '/api',
  unreachableHost: 'http://localhost:8000',
  // URL de la fiche Chrome Web Store de l'extension PromoDeep (vide tant qu'elle n'est pas publiée)
  chromeExtensionUrl: '',
  name: "local-prod",
  GA_TRACKING_ID: 'G-B0XK465P72',
  // Tag AdSense chargé au démarrage (il diffuse le message de consentement Google) ; Google Ads et emplacements AdSense après accord (ConsentService)
  GOOGLE_ADS_ID: 'AW-16502677796',
  GOOGLE_ADS_CONVERSION: 'AW-16502677796/LlDlCMvXm7waEKTCi709',
  ADSENSE_CLIENT: 'ca-pub-9110787490698390',
};
